/**
 * Shimmer
 *
 * Lightweight streaming text affordance for AI Elements.
 *
 * Primary responsibilities:
 * - Show an unobtrusive streaming state
 * - Respect reduced-motion users through Tailwind motion variants
 *
 * Dependencies:
 * - lib/utils
 */

'use client'

import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

export interface ShimmerProps extends ComponentProps<'span'> {
  active?: boolean
}

export function Shimmer({ active = true, className, ...props }: ShimmerProps) {
  return (
    <span
      className={cn(
        active && 'motion-safe:animate-pulse',
        !active && 'text-muted-foreground',
        className
      )}
      {...props}
    />
  )
}
